module.exports = __webpack_public_path__ + "static/media/Version.154f0e1b.txt";


//////////////////
// WEBPACK FOOTER
// ./src/Version.txt
// module id = 126
// module chunks = 1